export default __webpack_public_path__ + "static/media/3054.9edc80e0.jpg";